/**
 * 神獸作坊台：近景石座＋可轉鏡頭。開作坊時娃娃站在這，不是遠處走一圈。
 */

import { useEffect } from 'react'
import { OrbitControls } from '@react-three/drei'
import { useThree } from '@react-three/fiber'
import * as THREE from 'three/webgpu'
import { useGameStore } from '../core/store/gameStore'
import { terrainBuffer } from '../core/terrainBuffer'
import { WATER_LEVEL } from '../core/terrainConstants'
import { EMBROIDERY } from '../content/partLibrary'

export const STUDIO_XZ = { x: 8, z: 6 } as const

export function studioHeight() {
  if (!terrainBuffer.ready) return WATER_LEVEL
  return Math.max(terrainBuffer.getHeight(STUDIO_XZ.x, STUDIO_XZ.z), WATER_LEVEL)
}

export function StudioStage() {
  const open = useGameStore(s => s.makerOpen && s.makerKind === 'beast')
  const { camera } = useThree()
  const y = studioHeight()

  useEffect(() => {
    if (!open) return
    camera.position.set(STUDIO_XZ.x + 11, y + 6.5, STUDIO_XZ.z + 11)
  }, [open, camera, y])

  if (!open) return null

  return (
    <>
      <group position={[STUDIO_XZ.x, y, STUDIO_XZ.z]}>
        <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, 0.08, 0]}>
          <cylinderGeometry args={[2.4, 2.6, 0.28, 8]} />
          <meshStandardMaterial
            color="#7a6a52"
            roughness={0.96}
            metalness={0}
            flatShading
          />
        </mesh>
        <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, 0.24, 0]}>
          <cylinderGeometry args={[1.55, 1.7, 0.16, 7]} />
          <meshStandardMaterial
            color={EMBROIDERY.ochre}
            roughness={0.94}
            metalness={0}
            flatShading
          />
        </mesh>
      </group>
      <OrbitControls
        makeDefault
        enableDamping
        dampingFactor={0.14}
        enablePan={false}
        minDistance={7}
        maxDistance={26}
        minPolarAngle={0.35}
        maxPolarAngle={Math.PI / 2.15}
        target={[STUDIO_XZ.x, y + 2.1, STUDIO_XZ.z]}
      />
    </>
  )
}
